export default "__VITE_ASSET__C8iN$Ncd__"